<template>
  <div v-if="total > 0" class="m-pager">
    <button
      type="button"
      class="m-pager__btn"
      :disabled="page <= 1 || loading"
      :aria-label="prevLabel"
      @click="$emit('change', page - 1)"
    >
      <i class="fas fa-chevron-left" aria-hidden="true"></i>
    </button>
    <span class="m-pager__text">{{ rangeText }}</span>
    <button
      type="button"
      class="m-pager__btn"
      :disabled="page >= lastPage || loading"
      :aria-label="nextLabel"
      @click="$emit('change', page + 1)"
    >
      <i class="fas fa-chevron-right" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
/** Paginado compacto para el teléfono: «‹ 1–20 de 985 ›». Emite «change» con la página. */
export default {
  name: "MobilePager",
  props: {
    page: { type: Number, default: 1 },
    perPage: { type: Number, default: 20 },
    total: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    ofLabel: { type: String, default: "of" },
    prevLabel: { type: String, default: "Previous" },
    nextLabel: { type: String, default: "Next" },
  },
  computed: {
    lastPage() {
      return Math.max(1, Math.ceil(this.total / Math.max(1, this.perPage)));
    },
    rangeText() {
      const from = (this.page - 1) * this.perPage + 1;
      const to = Math.min(this.total, this.page * this.perPage);
      const fmt = (n) => Number(n).toLocaleString();
      return `${fmt(from)}–${fmt(to)} ${this.ofLabel} ${fmt(this.total)}`;
    },
  },
};
</script>

<style scoped>
.m-pager {
  clear: both; /* el contenedor del listado de escritorio flota */
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.5rem 0 5rem; /* deja lugar al botón flotante */
}
.m-pager__btn {
  width: 2.75rem;
  height: 2.75rem;
  border: 1px solid var(--m-border);
  border-radius: 50%;
  background: var(--m-surface);
  color: var(--bs-primary);
}
.m-pager__btn:disabled {
  color: var(--m-muted);
  opacity: 0.5;
}
.m-pager__text {
  min-width: 8rem;
  text-align: center;
  font-size: 0.9rem;
  color: var(--m-muted);
}
</style>
